import useFeatures from "@casino/legacy/client/hooks/feature/useFeatures";
import { useMemo } from "react";

const useLanguageFeatureFlags = () => {
  const featureFlags = useFeatures();

  const languageFeatureFlags: Partial<Record<LanguageCode, boolean>> = useMemo(
    () => ({
      ar: featureFlags["isArabianEnabled"],
      pt: featureFlags["isPortugueseEnabled"],
      tr: featureFlags["isTurkishEnabled"],
      fi: false,
      no: false,
      id: false,
    }),
    [featureFlags],
  );

  return languageFeatureFlags;
};

export default useLanguageFeatureFlags;
